import React, { FC, ReactNode } from 'react';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import CloseIcon from '@mui/icons-material/Close';
import {
  Modal as MaterialModal,
  ModalOwnProps,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import {
  BackButton,
  CloseButton,
  Dialog,
  Title,
} from 'src/components/Modals/styled';

export interface ModalProps extends ModalOwnProps {
  title: string | ReactNode;
  small?: boolean;
  onBack?: () => void;
  onClose?: () => void;
}

export const Modal: FC<ModalProps> = ({
  open,
  children,
  title,
  small = false,
  onBack,
  onClose,
  ...props
}) => {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <MaterialModal {...props} open={open} onClose={onClose}>
      <Dialog small={+small}>
        {onBack && (
          <BackButton
            onClick={onBack}
            color={isSmallScreen ? 'default' : 'secondary'}
          >
            <ArrowBackIcon />
          </BackButton>
        )}
        {onClose && (
          <CloseButton onClick={onClose}>
            <CloseIcon />
          </CloseButton>
        )}
        <Title small={+small} variant={small ? 'h4' : 'h1'} textAlign="center">
          {title}
        </Title>
        {children}
      </Dialog>
    </MaterialModal>
  );
};

export { ModalTerminiCondizioni } from './Terms';
export { ModalPrivacyPolicy } from './Privacy';
export { ModalDataDeletion } from './DataDeletion';
